/** Module 87 (WP-87.2b) — how many routes `routeCache` keeps (~90 bytes each). */
export const ROUTE_CACHE_CAP = 60;
